import { createContext } from "react";
import { match } from "react-router-dom";

type ModalRouteContextValue = match<Record<string, string>> | undefined;

export const ModalRouteContext = createContext<ModalRouteContextValue>(undefined);
